<template>
  <div class="orderLayout">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'orderLayout',
  data(){
    return {

    }
  },
  created(){

  },
  mounted(){




  },
  methods:{

  }
}
</script>

<style lang="less" scoped>
.orderLayout{
  position: relative;
  width: 100%;
  height: 100%;
}
</style>